// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"f822d4e2","406":"733f5596","486":"f822d4e2","772":"f822d4e2","825":"5be085da"}[chunkId] + ".chunk.css";
};